import styled from "@emotion/styled";
import { makeStyles } from "@material-ui/core/styles";
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { Autocomplete, Box, Button, Chip, Divider, Grid, IconButton, InputAdornment, Modal, Skeleton, TableCell, TableRow, TextField, Tooltip, Typography, tableCellClasses } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { fetchAccountSkuByName, fetchInventories, fetchItemCategories } from '../../store/inventoryStore/inventoryThunk';
import { Utils } from "../../utils/common-utils";
import { IOptions } from "../FormFields/CustomSelect";
import AddItem from "./AddItem";
import InputNumber from "./NumberInput";
import DefaultImg from './product.png';


export interface InventoryLineItem {
  id: number;
  seqNumber: number;
  skuCode?: string;
  _id?: string;
  name: string;
  description: string;
  mrp: string;
  appliedRate: number;
  unit: number;
  qty: number;
  discount: number;
  discountPercentage: number;
  discountAmount: number;
  taxableValue: number;
  tax: number;
  total: number;

}


const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  transition: '0ms',
  // width: 1260,
  width: '90%',
  height: '90vh',
  borderRadius: 2,
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: 24,
};

const useStyles = makeStyles({
  paper: {
    border: "1.5px solid #e9ecf1",
    width: '108%',
    boxShadow: 'none',
    marginLeft: '-6px',
    borderRadius: 7
  }
});

const BpIcon = styled('span')(({ theme }) => ({
  borderRadius: 3,
  width: 15,
  height: 15,
  boxShadow:
    //   theme.palette.mode === 'dark'
    // ? '0 0 0 1px rgb(16 22 26 / 40%) ' :
    'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
  backgroundColor:
    // theme.palette.mode === 'dark' ? '#394b59' : 
    '#f5f8fa',
  backgroundImage:
    //   theme.palette.mode === 'dark'
    // ? 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))' :
    'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
  '.Mui-focusVisible &': {
    outline: '2px auto rgba(19,124,189,.6)',
    outlineOffset: 2,
  },
  'input:hover ~ &': {
    backgroundColor:
      //   theme.palette.mode === 'dark' ? '#30404d' : 
      '#ebf1f5',
  },
  'input:disabled ~ &': {
    boxShadow: 'none',
    background:
      // theme.palette.mode === 'dark' ? 'rgba(57,75,89,.5)' : 
      'rgba(206,217,224,.5)',
  },
}));

const BpCheckedIcon = styled(BpIcon)({
  backgroundColor: '#137cbd',
  backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
  '&:before': {
    display: 'block',
    width: 15,
    height: 15,
    backgroundImage:
      "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
      " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
      "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
    content: '""',
  },
  'input:hover ~ &': {
    backgroundColor: '#106ba3',
  },
});


const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#fff',
    color: '#9da7b7',
    borderTop: '0.25px solid #d9d4d4',
    borderBottom: '0.25px solid #d9d4d4',
    margin: 0,
    padding: 0,
    paddingLeft: '15px !important',
  },
  [`&.${tableCellClasses.footer}`]: {
    backgroundColor: '#f5f5f5',
    color: 'black',
    borderTop: '0.25px solid #d9d4d4',
    borderBottom: '0.25px solid #d9d4d4',
    left: 0,
    bottom: 0, // <-- KEY
    zIndex: 2,
    position: 'sticky'
  },
  [`&.${tableCellClasses.body}`]: {
    verticalAlign: 'super',
    fontSize: 14,
    padding: 5,
    border: 'none',
    paddingLeft: '15px !important',
    margin: 0
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(even)': {
    backgroundColor: '#fbfbfb',
    // border: '0.5px dashed #9da7b7',
  },
  '&:nth-of-type(odd)': {
    backgroundColor: '#e9ecf1',
    // border: '0.5px dashed #9da7b7',
  },
  // hide last border
  '&:last-child td, &:last-child th': {
  },
}));

const ItemModel = (props: any) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const classes = useStyles();
  const TIME_DELAY = 500;

  const { inventories, status } = useAppSelector(state => state.inventories);
  const { permissions, selectedAccount } = useAppSelector(state => state.auth);
  const [items, setItems] = useState<any[]>([]);
  const [suggestedItems, setSuggestedItems] = useState<any[]>([]);
  const [newCartItemId, setNewCartItemId] = useState("");
  const [isNewCart, setIsNewCart] = useState("");
  const [cart, setCart] = useState<any[]>([]);
  const [addItem, setAddItem] = useState(false);
  const [checkAll, setCheckAll] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [reloadItems, setReloadItems] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // Filters States
  const [itemCategoryOptions, setItemCategoryOptions] = useState<IOptions[]>([]);
  const [itemCategoryId, setItemCategoryId] = useState("");
  const [itemCategoryValue, setItemCategoryValue] = useState(null);
  const [filterItemName, setFilterItemName] = useState("");

  const onClose = () => {
    props.setVisible(false);
    setItems(inventories);
    setCart([]);
    setCheckAll(false);
    setTotalAmount(0);
  }

  /**
  * Fetch all the accounts on Accounts page load.
  */

  useEffect(() => {
    let isMounted = true;
    const getItemCategories = async () => {
      let options: IOptions[] = [];
      const data: any = await dispatch(fetchItemCategories());
      if (data.payload.length > 0) {
        await data.payload.forEach(async (item: string | any) => {
          options.push({ label: item.name, value: item._id })
        });
        if (isMounted && options.length > 0) {
          setItemCategoryOptions(options);
        }
      }
    }
    getItemCategories();
    return () => {
      isMounted = false;
    };

  }, []);

  useEffect(() => {
    console.log("useEffect called 1111 fetchInventories =========>");
    const { _id: id } = selectedAccount;
    dispatch(fetchInventories({ accountId: id, type: '', params: '' }));
  }, [dispatch, selectedAccount]);

  useEffect(() => {
    console.log("useEffect called 222");
    console.log(inventories);
    if (inventories.length > 0) {
      const updatelist = prepareLineItems(inventories);
      // var i = 0
      // const updatelist = inventories.map((c:any) => {
      //     i = i + 1
      //     return {...c,
      //       id: i,
      //       appliedRate: c.sale.price,
      //       purchasePrice: c.purchase ? c.purchase.price : '-',
      //       taxPercentage: c.gst ? Number(c.gst.value) : 0,
      //       wholeSalePrice: c.wholeSale ? Number(c.wholeSale.price) : '-',
      //       inStock: c.stock.currentStock,
      //       unit: c.sale.unit.code,
      //       discount: (c.discount && c.discount.discountAmount) ? c.discount.discountAmount : 0,
      //       discountPercentage: (c.discount && c.discount.discountPercent) ? c.discount.discountPercent : 0,
      //       checked: false,
      //       qty:0,
      //       igst: 0,
      //       igsttotal: 0,
      //       cgst: 0,
      //       cgsttotal: 0,
      //       sgst: 0,
      //       sgsttotal: 0,
      //       total: 0,
      //       _id: '',
      //       skuCode: c._id != '' ? c._id : ''
      //     };
      // });
      setItems(updatelist);
      // setNewCartItemId('');
    }
  }, [inventories, reloadItems]);

  useEffect(() => {
    searchItems('');
    setNewCartItemId('');
  }, [])

  useEffect(() => {
    TotalAmount();
    if (cart.find(e => e.checked === false)) {
      setCheckAll(false);
    } else {
      setCheckAll(true);
    }
  }, [cart])


  const onSubmit = () => {
    if (cart && cart.length > 0) {
      let data: any = [];
      cart.map((c) => {
        if (c.checked === true) {
          data.push(c);
        }
      });
      props.itemData(data);
      props.setVisible(false);
      // setItems(inventories);
      setCheckAll(false);
      setTotalAmount(0);
      setCart([]);
    }
  }

  const TotalAmount = () => {
    let num = 0;
    cart.map((o, i) => {
      if (o.checked === true) {
        num = num + o.appliedRate * o.qty;
      }
    })
    setTotalAmount(num);
  }

  const searchItems = async (searchValue: string) => {
    setNewCartItemId('');
    setFilterItemName(searchValue);
  }

  useEffect(() => {
    setIsLoading(true);
    // setSelectedInvoices([]);
    let filter = (itemCategoryId && itemCategoryId != '') ? `&category=${itemCategoryId}` : '';
    let queryString = `name=${filterItemName}${filter}`;
    setNewCartItemId('')

    const timerId = setTimeout(() => {
      dispatch(fetchAccountSkuByName(queryString)).unwrap().then((data: any) => {
        if (data) {
          if (data.inventories && data.inventories.length > 0) {
            const updatelist = prepareLineItems(data.inventories);
            // setCart([...cart, updatelist]);
            setItems(updatelist);
            setNewCartItemId('');
            setIsLoading(false);
          } else {
            setNewCartItemId('');
            setIsLoading(false);
          }
        }
      }).catch(e => {
        setIsLoading(false);
        // console.log(e);
      });
    }, TIME_DELAY);  // 200ms delay





    // dispatch(fetchAccountSkuByName(queryString)).unwrap().then((data: any) => {
    //   if (data) {
    //     if(data.inventories && data.inventories.length > 0) {
    //       const updatelist = prepareLineItems(data.inventories);
    //       // setCart([...cart, updatelist]);
    //       setItems(updatelist);
    //       setNewCartItemId('');
    //     } else {
    //       setNewCartItemId('');
    //     }
    //   }
    // });
  }, [dispatch, filterItemName, itemCategoryId, reloadItems]);

  useEffect(() => {
    setIsLoading(true);
    let queryString = '';
    if (newCartItemId && newCartItemId != '') {
      queryString += `&parentSkuId=${newCartItemId}`;
    }

    const timerId = setTimeout(() => {
      dispatch(fetchAccountSkuByName(queryString)).unwrap().then((data: any) => {
        if (data) {
          if (data.inventories && data.inventories.length > 0) {
            const updatelist = prepareLineItems(data.inventories);
            setItems(updatelist);
            setIsLoading(false);
          } else {
            setNewCartItemId('');
            setIsLoading(false);
          }
        }
      }).catch(e => {
        setIsLoading(false);
        // console.log(e);
      });
    }, TIME_DELAY);  // 200ms delay

  }, [dispatch, isNewCart]);

  useEffect(() => {
    TotalAmount();
    if (cart.find(e => e.checked === false)) {
      setCheckAll(false);
    } else {
      setCheckAll(true);
    }
    console.log(cart);
  }, [cart])

  const prepareLineItems = (data: any) => {
    var i = 0
    return data.map((c: any) => {
      i = i + 1
      return {
        ...c,
        id: i,
        // seqNumber: i,
        appliedRate: (c.sale && c.sale.price) ? c.sale.price : 0,
        purchasePrice: c.purchase ? c.purchase.price : '-',
        taxPercentage: c.gst ? Number(c.gst.value) : 0,
        wholeSalePrice: c.wholeSale ? Number(c.wholeSale.price) : '-',
        inStock: c.stock.currentStock,
        unit: (c.sale && c.sale.unit && c.sale.unit.code) ? c.sale.unit.code : '',
        discount: (c.discount && c.discount.discountAmount) ? c.discount.discountAmount : 0,
        discountPercentage: (c.discount && c.discount.discountPercent) ? c.discount.discountPercent : 0,
        checked: false,
        qty: 0,
        igst: 0,
        igsttotal: 0,
        cgst: 0,
        cgsttotal: 0,
        sgst: 0,
        sgsttotal: 0,
        total: 0,
        _id: '',
        skuCode: c._id != '' ? c._id : ''
      };
    });
  };

  const onChangeCategory = (data: any) => {
    setNewCartItemId('');
    setItemCategoryValue(data);
    setItemCategoryId(data.value);
  }

  return (
    <>
      <AddItem visible={addItem} setVisible={setAddItem} />
      <Modal
        open={props.visible}
        onClose={(event: any, reason: any) => {
          if (reason !== 'backdropClick') {
            props.setVisible(true)
          }
        }}
      >
        <Box sx={style}>
          <Grid container pt={0}>
            <Grid {...{ xs: 12, sm: 8, md: 4, lg: 12, p: 2, pl: 2, bgcolor: '#e9ecf1' }} style={{ borderTopLeftRadius: 8, borderTopRightRadius: 8, height: 50 }} >

              <Grid container >

                <Grid item xs={1.3}><h3 style={{ marginTop: -5 }}>Add Item</h3></Grid>
                <Grid item xs={4}>
                  <IconButton onClick={() => setReloadItems(Math.random().toString(36).substring(2, 7))}
                    style={{ float: 'left', color: '#545454', backgroundColor: '#fff', border: 'none', height: 35, width: 35, marginTop: -7, marginRight: 10, marginLeft: -5 }}
                    size='small'
                  >
                    <Tooltip title="Refresh Inventory Items"><RefreshRoundedIcon style={{ fontSize: 20 }} /></Tooltip>
                  </IconButton>
                  <TextField
                    placeholder='Search'
                    style={{ marginTop: -10, width: '90%' }}
                    onChange={(e) => searchItems(e.target.value.toString())}
                    className='c-text-field-3'
                    variant="standard"
                    size='small'
                    InputProps={{
                      disableUnderline: true,
                      startAdornment: <InputAdornment position="end"><SearchOutlinedIcon style={{ fontSize: 16, marginRight: 2, paddingLeft: 0, marginLeft: -3, marginBottom: 2 }} /></InputAdornment>,
                    }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Autocomplete
                    id="itemCategoryOptionsAutocomplete"
                    disablePortal
                    value={itemCategoryValue}
                    options={itemCategoryOptions && itemCategoryOptions.map(e => ({ value: e.value, label: e.label }))}
                    getOptionLabel={(option) => option.label}
                    onChange={(event, value) => onChangeCategory(value)}
                    renderOption={(props, option: { label: string }) => (
                      <li {...props}
                        style={{ fontSize: 14, height: 40 }}
                      >{option.label}</li>
                    )}
                    classes={{ paper: classes.paper }}
                    sx={{ marginTop: '-10px', width: '100%' }}
                    renderInput={(params) => <TextField {...params}
                      placeholder="Select Item Category"
                      required
                      className='c-text-field-3'
                      variant="standard"
                      size='small'
                      InputProps={{ ...params.InputProps, disableUnderline: true }}
                    />}
                  />
                </Grid>

                {/* <Grid item xs={3.3}>
                  <Button size='small' className='c-dashed-button' variant='outlined' sx={{ marginTop:-0.7,borderStyle:'dashed',borderRadius:'5px',width:'95%'}}
                      onClick={()=> setAddItem(true)}>Create New Item</Button>
                </Grid> */}

                <div style={{ position: 'absolute', right: 7, top: 7 }}>
                  {/* <IconButton size='small' onClick={() => setReloadItems(Math.random().toString(36).substring(2, 7))} >
                    <ReplayOutlinedIcon color="primary" />
                  </IconButton> */}
                  {/* <IconButton size='small'
                   onClick={() => onSubmit()} >
                    <CheckCircleOutlineOutlinedIcon color="primary" />
                  </IconButton> */}
                  <Button
                    className={'buttonContainedRoot'}
                    size='small'
                    onClick={() => onSubmit()}
                    style={{ color: '#488dff', backgroundColor: '#fff', border: '0.5px solid #488dff', height: 35, borderRadius: 7, marginRight: 10 }}
                    variant="contained"
                  >
                    Continue
                  </Button>

                  <Button
                    className={'buttonContainedRoot'}
                    size='small'
                    onClick={() => onClose()}
                    style={{ color: '#c33b3b', backgroundColor: '#fff', border: '0.5px solid #c33b3b', height: 35, borderRadius: 7 }}
                    variant="contained"
                  >
                    Cancel
                  </Button>
                  {/* <Button variant="outlined" color="primary" style={{borderWidth:2.5,borderRadius:25,height:25,fontSize:12,paddingTop:6,paddingLeft:'0px',paddingRight:'0px',marginTop:1,width:'auto',minWidth:'50px'}}>Add</Button> */}
                  {/* <IconButton size='small' onClick={() => onClose()} style={{ marginRight: -5 }} >
                    <HighlightOffOutlinedIcon color="error" />
                  </IconButton> */}
                </div>
              </Grid>
            </Grid>

            {/* {JSON.stringify(items)} */}

          </Grid>
          <Grid container style={{ height: '100%' }} >

            <Grid item xs={7.5} style={{ width: '65%', position: 'absolute', top: 50, bottom: 0, overflow: 'auto', borderRight: '1px solid #e9ecf1' }}>
              <Grid container p={2} spacing={2}>

                {items.length <= 0 ? <div style={{ height: '100%', width: '100%', marginTop: '30%', textAlign: 'center' }}><h2 style={{ color: '#9da7b7' }}>Please Add Item</h2></div> :
                  <>
                    {(newCartItemId && newCartItemId != '') &&
                      <Grid item xs={12}>
                        <Typography style={{ fontSize: 16, fontWeight: 500 }}>
                          Would you like to add sub items to the cart ?
                          <Button
                            className={'buttonContainedRoot'}
                            size='small'
                            onClick={() => setReloadItems(Math.random().toString(36).substring(2, 7))}
                            style={{ color: '#488dff', backgroundColor: '#fff', border: '0.5px solid #488dff', height: 35, borderRadius: 7, marginLeft: 10 }}
                            // style={{ color: '#c33b3b', backgroundColor: '#fff',border:'0.5px solid #c33b3b',height:35,borderRadius:7,marginLeft:10}}
                            variant="contained"
                          >
                            No I Don't. Load All Items...
                          </Button>

                        </Typography>
                      </Grid>
                    }
                    {isLoading ?
                      <>
                        {Array.from(Array(18).keys()).map((e: any) =>
                          <Grid item xs={4}>
                            <div className={'c-card2'} style={{ padding: 10, paddingLeft: 10, border: '' }}>

                              <Grid container>
                                <Grid item xs={3.5}>
                                  <Skeleton animation="wave" variant="circular" width={30} height={30} />
                                </Grid>
                                <Grid item xs={8}>
                                  <Skeleton animation="wave" height={20} />
                                  <Skeleton animation="wave" height={20} />
                                </Grid>
                              </Grid>
                              <Skeleton animation="wave" height={20} />

                            </div>
                          </Grid>
                        )}
                      </>
                      : items.map((e: any) =>
                        <Grid key={e.id} item xs={4}>
                          <div className={'c-card2'} style={{ padding: 10, paddingLeft: 10, border: cart.filter(o => o.id === e.id).length ? '1px solid #488dff' : '' }}>

                            <Grid container>
                              <Grid item xs={3.5}>
                                <img src={DefaultImg} style={{ objectFit: 'contain', padding: 10, width: 50, height: 50, borderRadius: 7, border: '.5px solid #e9ecf1' }} />
                              </Grid>
                              <Grid item xs={8}>
                                <Tooltip title={e.description} placement="top-start">
                                  <p style={{ fontSize: 13, height: 40 }}>{String(e.name).length > 55 ? String(e.name).substring(0, 55) + '...' : String(e.name)}</p>
                                </Tooltip>
                              </Grid>
                            </Grid>
                            <IconButton
                              onClick={() => {
                                // const updatelist = items.map((c: any) => {
                                //   if (c.id === e.id) {
                                //     return { ...c, checked: true, qty: e.qty + 1 };
                                //   } else {
                                //     return c;
                                //   }
                                // });
                                // let s = { ...items };
                                // s = updatelist;
                                // setItems(s);
                                // setNewCartItemId(e.skuCode)
                                if (cart.length > 0) {
                                  const updatelist = cart.map((c: any) => {
                                    if (c.skuCode === e.skuCode) {
                                      return { ...c, checked: true, qty: c.qty + 1 };
                                    } else {
                                      return c;
                                    }
                                  });

                                  if (updatelist.length > 0) {
                                    console.log(updatelist[0].id, e.id);
                                    if (updatelist.filter(o => o.skuCode === e.skuCode).length > 0) {
                                      let s = { ...cart };
                                      s = updatelist;
                                      setCart(s);
                                    } else {
                                      setCart([...cart, { ...e, checked: true, qty: 1 }]);
                                    }
                                  } else {
                                    setCart([...cart, { ...e, checked: true, qty: 1 }]);
                                  }
                                } else {
                                  setCart([...cart, { ...e, checked: true, qty: 1 }]);
                                }
                                // find Associated Sku and add to cart
                                setNewCartItemId(e.skuCode)
                                setIsNewCart(Math.random().toString(36).substring(2, 7));
                              }}
                              style={{ float: 'right', fontSize: 14, marginLeft: 10, color: '#488dff', backgroundColor: '#f1f0fc', border: '1px solid #488dff', height: 25, borderRadius: 8 }}
                              size='small' ><AddRoundedIcon style={{ fontSize: 16 }} /> Add</IconButton>
                            <span style={{ float: 'right', fontSize: 12, marginTop: 2.5 }}>{e.inStock} <span style={{ color: '#9da7b7' }}>{e.unit}</span></span>
                            <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14 }}>{(e.appliedRate && e.appliedRate > 0) && '₹ ' + e.appliedRate}</h5>

                          </div>
                        </Grid>)}</>}

                {/* {items.length <= 0 ? <div style={{height:'100%',width:'100%',marginTop:'30%',textAlign:'center'}}><h2 style={{color:'#9da7b7'}}>Please Add Item</h2></div> :
                <>{items.map((e: any) =>
                  <Grid key={e.id} item xs={2.4}>
                    <div className={'c-card2'} style={{ padding: 10, paddingLeft: 10, border: cart.filter(o=> o.id === e.id).length ? '1px solid #488dff' : '' }}>
                      <IconButton
                        onClick={() => {
                          // const updatelist = items.map((c: any) => {
                          //   if (c.id === e.id) {
                          //     return { ...c, checked: true, qty: e.qty + 1 };
                          //   } else {
                          //     return c;
                          //   }
                          // });
                          // let s = { ...items };
                          // s = updatelist;
                          // setItems(s);
                          if(cart.length > 0) {
                            const updatelist = cart.map((c: any) => {
                              if (c.id === e.id) {
                                return { ...c, checked: true, qty: c.qty + 1 };
                              } else {
                                return c;
                              }
                            });

                            if(updatelist.length > 0) {
                              console.log(updatelist[0].id, e.id);
                              if(updatelist.filter(o=> o.id === e.id).length > 0) {
                                let s = { ...cart };
                                s = updatelist;
                                setCart(s);
                              } else {
                                setCart([...cart, { ...e, checked: true, qty: 1 }]);
                              }
                            } else {
                              setCart([...cart, { ...e, checked: true, qty: 1 }]);
                            }
                          } else {
                            setCart([...cart, { ...e, checked: true, qty: 1 }]);
                          }
                        }}
                        style={{ float: 'right', marginTop: -18, marginRight: -18, color: '#488dff', backgroundColor: '#f1f0fc', border: '1px solid #488dff', height: 30, width: 30 }}
                        size='small' ><AddRoundedIcon style={{ fontSize: 20 }} /></IconButton>

                      <img src={DefaultImg} style={{ marginTop: -15, objectFit: 'contain', padding: 10, width: '100%', borderRadius: 7, border: '.5px solid #e9ecf1', height: 100 }} />
                      <p style={{ fontSize: 13, height: 60 }}>{String(e.name).length > 55 ? String(e.name).substring(0, 55) + '...' : String(e.name)}</p>
                      <span style={{ float: 'right', fontSize: 12, marginTop: 2.5 }}>{e.inStock} <span style={{ color: '#9da7b7' }}>{e.unit}</span></span>
                      <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14 }}>{(e.appliedRate && e.appliedRate > 0) && '₹ ' + e.appliedRate}</h5>
                    </div>
                  </Grid>)}</>} */}


              </Grid>
            </Grid>
            <Grid item xs={4.5} pb={5} style={{ width: '36%', position: 'absolute', top: 50, bottom: 0, right: 5, overflow: 'auto' }}>

              {cart.filter(e => e.checked === true).length <= 0 ? <h2 style={{ color: '#9da7b7', textAlign: 'center', marginTop: '50%' }}>Please Select Item</h2> :

                <>{cart.filter(e => e.checked === true).map((e: any, index: any) =>

                  <Grid key={e.id} container style={{ borderBottom: '1px solid #e9ecf1' }} pt={1} pb={1}>

                    <Grid item xs={8} mb={1}>
                      <h5 style={{ fontWeight: '700', color: '#000', fontSize: 14 }}>{e.name}</h5>
                    </Grid>
                    <Grid item xs={4}>
                      <IconButton
                        onClick={() => {
                          setCart(cart.filter(o => o.skuCode !== e.skuCode));
                        }}
                        style={{ float: 'right', marginTop: 0, marginRight: 10, color: '#c33b3b', backgroundColor: '#fbecec', border: '1px solid #c33b3b', height: 25, width: 25 }}
                        size='small' ><CloseRoundedIcon style={{ fontSize: 16 }} /></IconButton>
                      {(e.appliedRate && e.appliedRate > 0) &&
                        <>
                          <Tooltip title={`Sale Price`}>
                            <Chip size='small' style={{ float: 'right', marginRight: 8, borderRadius: 7, backgroundColor: '#e5e5f9', fontWeight: 700 }} label={(e.appliedRate && e.appliedRate > 0) && `${Utils.formatNumber(e.appliedRate)}`} />
                          </Tooltip>
                        </>
                      }
                    </Grid>
                    <Grid item xs={4}>
                      <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 12 }}>MRP</h5>
                      <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 3 }}>{(e.mrp && e.mrp > 0) ? Utils.formatNumber(e.mrp) : '-'}</h5>
                    </Grid>
                    <Grid item xs={4}>
                      <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 12 }}>PURCHASE PRICE</h5>
                      <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 3 }}>{(e.purchasePrice && e.purchasePrice > 0) ? Utils.formatNumber(e.purchasePrice) : '-'}</h5>
                    </Grid>


                    <Grid item xs={4} pt={1} pl={2}>
                      <InputNumber
                        steps={1}
                        myvalue={e.checked === false ? 0 : e.qty}
                        // min={1} max={999} value={e.checked === true ? e.qty : 0}
                        onChange={(val) => {
                          if (val && val) {
                            if (val <= 0) {
                              setCart(cart.filter(o => o.skuCode !== e.skuCode));
                            }
                            else {
                              const updatelist = cart.map((c: any) => {
                                if (c.skuCode === e.skuCode) {
                                  return { ...c, checked: true, qty: val };
                                } else {
                                  return c;
                                }
                              });
                              let s = { ...cart };
                              s = updatelist;
                              setCart(s);
                            }
                          }
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      {(e.wholeSalePrice && e.wholeSalePrice > 0) ? <Chip size='small' style={{ borderRadius: 7, color: '#49a563', backgroundColor: '#edf6ef', marginRight: 10 }} label={<>{'₹ ' + e.wholeSalePrice}</>} /> : ''}
                      {(e.discount && e.discount > 0) ? <Chip size='small' style={{ borderRadius: 7, color: '#488dff', backgroundColor: '#f1f0fc' }} label={<>Discount : {'₹ ' + e.discount} {e.discountPercentage > 0 ? `(${e.discountPercentage}%)` : ''}</>} /> : ''}
                      {e.inStock ? <Chip size='small' style={{ float: 'right', marginRight: 20, borderRadius: 7, backgroundColor: '#fafafb' }} label={<span>{e.inStock} <span style={{ color: '#9da7b7' }}>{e.unit}</span></span>} /> : ''}
                    </Grid>
                  </Grid>)}</>}


              <div style={{ height: 40, position: 'fixed', width: '36%', bottom: 0, backgroundColor: '#fff' }}>
                {cart.filter(e => e.checked === true).length === 0 ? '' : <>
                  <Divider />
                  <Grid container spacing={0} p={0.5}>
                    <Grid item xs={5} >
                      <h4 style={{ fontSize: 14, fontWeight: 400, color: '#488dff' }}>{cart.filter(e => e.checked === true).length} Items Selected </h4>
                    </Grid>
                    <Grid item xs={7} >
                      <h4 style={{ textAlign: 'right', fontSize: 16, marginRight: 10, fontWeight: 400 }}>Total Amount : <b> ₹ {totalAmount}</b> </h4>
                    </Grid>
                  </Grid></>}
              </div>

            </Grid>
          </Grid>

          {/* <div style={{height:200, overflowX:'auto',overflowY:'auto',marginBottom:7}}>
          <Table stickyHeader sx={{ minWidth: 700}} size='small' aria-label="customized table">
          <TableHead>
              <TableRow>
                  <StyledTableCell align="left" width={5}>
                      <Checkbox
                      sx={{
                          '&:hover': { bgcolor: 'transparent' },
                          ml:-1
                      }}
                      checked={checkAll}
                      onChange={()=>{
                        setTotalAmount(0);
                        setCheckAll(!checkAll);
                        const updatelist = items.map((c:any) => {
                              return {...c, checked: !checkAll, qty:checkAll === true ? 0 : c.qty > 0 ? c.qty : 1};
                          });
                          let s = {...items};
                          s = updatelist;
                          setItems(s);
                      }}
                      disableRipple
                      checkedIcon={<BpCheckedIcon />}
                      icon={<BpIcon />}
                  /></StyledTableCell>
                  <StyledTableCell width={200}>ITEM NAME </StyledTableCell> 
                  <StyledTableCell>HSN CODE</StyledTableCell>
                  <StyledTableCell>MRP</StyledTableCell>
                  <StyledTableCell>PURCHASE PRICE</StyledTableCell>
                  <StyledTableCell>SALE PRICE</StyledTableCell>
                  <StyledTableCell>WHOLESALE RATE</StyledTableCell>
                  <StyledTableCell>Discount</StyledTableCell>
                  <StyledTableCell>IN STOCK</StyledTableCell>
                  <StyledTableCell align="left" width={100}>QUANTITY</StyledTableCell>
              </TableRow>
          </TableHead>
          <TableBody>
            
              {items.map((e:any) => 
              <StyledTableRow key={e.id}>
                  <StyledTableCell align="left" >
                      <Checkbox
                      sx={{
                          '&:hover': { bgcolor: 'transparent' },
                          ml:-1
                      }}
                      checked={e.checked || e.qty>0}
                      onChange={()=>{
                          const updatelist = items.map((c:any) => {
                              if (c.id === e.id) {
                                console.log(c.id)
                                console.log(e.id)
                                return {...c, checked: !c.checked, qty:c.checked === true ? 0 : 1};
                              } else {
                                return c;
                              }
                            });
                            let s = {...items};
                            s = updatelist;
                            setItems(s);
                      }}
                      // onClick={()=> setShip(!ship)}
                      disableRipple
                      checkedIcon={<BpCheckedIcon/>}
                      icon={<BpIcon />}
                  /></StyledTableCell>
                  <StyledTableCell align="left">{e.name}</StyledTableCell>
                  <StyledTableCell align="left">{(e.hsnCode && e.hsnCode != '') ? e.hsnCode : '-'}</StyledTableCell>
                  <StyledTableCell align="left">{(e.mrp && e.mrp > 0) && '₹ '+ e.mrp}</StyledTableCell>
                  <StyledTableCell align="left">{(e.purchasePrice && e.purchasePrice > 0) && '₹ '+ e.purchasePrice}</StyledTableCell>
                  <StyledTableCell align="left">{(e.appliedRate && e.appliedRate > 0) && '₹ '+ e.appliedRate}</StyledTableCell>
                  <StyledTableCell align="left">{(e.wholeSalePrice && e.wholeSalePrice > 0) && '₹ '+e.wholeSalePrice}</StyledTableCell>
                  <StyledTableCell align="left">{(e.discount && e.discount > 0) && '₹ '+ e.discount} {e.discountPercentage > 0 ? `(${e.discountPercentage}%)` : ''}</StyledTableCell>
                  <StyledTableCell align="left">{e.inStock} {e.unit}</StyledTableCell>
                  <StyledTableCell align="right">
                      <div style={{float:'right',height:18,marginRight:10}}>
                          <InputNumber 
                          steps={1}
                          myvalue={e.checked === false ? 0 : e.qty}
                          // min={1} max={999} value={e.checked === true ? e.qty : 0}
                          onChange={(val)=> {
                              if(val && val) {
                              const updatelist = items.map((c:any) => {
                                  if (c.id === e.id) {
                                    return {...c, checked: val <= 0 ? false : true, qty: val};
                                  } else {
                                    return c;
                                  }
                                });
                                let s = {...items};
                                s = updatelist;
                                setItems(s);
                              } 
                          }}/>
                      </div>
                  </StyledTableCell>
              </StyledTableRow>)}
              
              
          </TableBody>
          </Table>
          </div> */}

        </Box>
      </Modal>
    </>
  )
};
export default ItemModel;